import { useConnectZkex } from 'hooks/useConnectZkex'
import { throttle } from 'lodash'
import { FC, memo, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { useZkexConnecting } from 'store/account/hooks'
import { ConnectButtonWrap } from './ConnectWallet'

export const EnableTradingButton: FC<{ children?: ReactNode }> = memo(
  ({ children }) => {
    const { t } = useTranslation()
    const connectZkex = useConnectZkex()
    const zkexConnecting = useZkexConnecting()

    const onHandleConnect = throttle(connectZkex, 1000)

    if (zkexConnecting) {
      return (
        <ConnectButtonWrap loading disabled fullWidth>
          Processing
        </ConnectButtonWrap>
      )
    }
    return (
      <ConnectButtonWrap fullWidth onClick={onHandleConnect}>
        {children ?? t('create-order-enable-trading')}
      </ConnectButtonWrap>
    )
  },
)
